if (!customElements.get('klaviyo-form-reload')) {
  customElements.define(
    'klaviyo-form-reload',
    class KlaviyoFormReload extends HTMLElement {
      constructor() {
        super();
        this.KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/Y5frTe/klaviyo.js?company_id=Y5frTe';
        this.checkDelay = parseInt(this.dataset.checkDelay) || 2500;
      }

      connectedCallback() {
        setTimeout(() => this.checkKlaviyo(), this.checkDelay);
      }

      isKlaviyoReady() {
        const k = window._klOnsite;
        // Not created or still a stub array
        if (!k || (Array.isArray(k) && !k._loaded)) {
          return false;
        }
        return true;
      }

      reloadKlaviyo() {
        console.log('Reloading Klaviyo…');

        // Remove old script if exists
        const old = document.querySelector('script[src*="klaviyo.com/onsite/js"]');
        if (old) old.remove();

        // Create new script
        const script = document.createElement('script');
        script.src = this.KLAVIYO_SRC;
        script.async = true;
        document.head.appendChild(script);
        console.log('Klaviyo script inserted');
      }

      checkKlaviyo() {
        if (!this.isKlaviyoReady()) {
          console.log('Klaviyo failed to initialize, reloading…');
          this.reloadKlaviyo();
          return;
        }

        console.log('Klaviyo initialized correctly');
      }
    }
  );
}
